import axios from "../../interceptors/axiosInterceptor";
import {
  GET_ACCESS_CONTROL_USERS_URL,
  GET_ACCESS_CONTROL_USER_DETAIL_V2_URL,
  GET_ALL_CLIENTS_AND_ROLES_URL,
  ADD_REMOVE_USER_TO_ROLE_URL,
  ADD_REMOVE_USER_TO_CLIENT_URL,
  GET_PRODUCT_BRANDS_URL,
  GET_ALL_FILTERS_URL,
} from "../../config/Url";
import {
  IGetQueryParams,
  IAllClientRolesResponse,
  IClientsResponseObject,
  IProductCategory,
  IDropDownResponse,
  IFilterPayload,
} from "../../interfaces/Index";
import { getAuthOptions } from "../../config/Headers";
import {
  normalizeFetchAccessControlUserResponse,
  normalizedClientsRoles,
} from "../../normalizer/AccessControlNormalizer";
import { normalizeCatchErrors } from "../../utils/errorUtils";

interface IClientPayload {
  clientIds: string[];
}
interface IRolePayload {
  roleIds: string[];
}

export const fetchAccessControlUserApiCall = (
  queryParam: IGetQueryParams = {}
) =>
  new Promise((resolve, reject) => {
    let requestConfig: any = getAuthOptions();
    requestConfig.params = queryParam;
    axios
      .get(GET_ACCESS_CONTROL_USERS_URL, requestConfig)
      .then((response) => {
        if (response) {
          const data = response && response.data;
          const pageNumber: number = queryParam.page
            ? Number(queryParam.page) + 1
            : 1;
          const isPaginatedRes =
            queryParam.page && (queryParam.page as any) > 0 && data.length >= 50
              ? true
              : false;
          resolve(
            normalizeFetchAccessControlUserResponse(
              data,
              pageNumber,
              isPaginatedRes
            )
          );
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getAccessControlUserDetailsNewApiCall = (id: string) =>
  new Promise((resolve, reject) => {
    let url = GET_ACCESS_CONTROL_USER_DETAIL_V2_URL.replace("{user_id}", id);
    axios
      .get(url, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });

export const getAllUserRoleAndClientsAPICall = (): Promise<
  IClientsResponseObject[]
> => {
  return new Promise((resolve, reject) => {
    axios
      .get(GET_ALL_CLIENTS_AND_ROLES_URL, getAuthOptions())
      .then((response) => {
        if (response) {
          const data: IAllClientRolesResponse = response && response.data;
          const normalizedClientsRolesResponse: IClientsResponseObject[] =
            normalizedClientsRoles(data);
          resolve(normalizedClientsRolesResponse);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const addUserToRole = (userId: string, payload: IRolePayload) => {
  return new Promise<void>((resolve, reject) => {
    let url = ADD_REMOVE_USER_TO_ROLE_URL.replace("{user_id}", userId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const addUserToClient = (userId: string, payload: IClientPayload) => {
  return new Promise<void>((resolve, reject) => {
    let url = ADD_REMOVE_USER_TO_CLIENT_URL.replace("{user_id}", userId);
    axios
      .put(url, payload, getAuthOptions())
      .then((response) => {
        if (response) {
          resolve();
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
};

export const fetchAllFiltersApiCall = () =>
  new Promise<Array<IFilterPayload>>((resolve, reject) => {
    axios
      .get(GET_ALL_FILTERS_URL, getAuthOptions())
      .then((response) => {
        if (response) {
          const data = response && response.data;
          resolve(data);
        } else {
          reject({ errors: "Something went wrong" });
        }
      })
      .catch((error) => {
        const errorPayload = normalizeCatchErrors(error.response);
        reject(errorPayload);
      });
  });
